export const enum ArTemplatesListMenuActions {
    DELETE = 'DELETE',
}
